<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Empowering Businesses with Purposeful AI and Human-Centered Software Solutions
          </h1>
          <p class="softwaredev-subheading2 mb-4">
            Driving transformation through innovative technology, trusted partnerships, and scalable impact.
          </p>
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Let’s Build Together
            </button>
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <video #heroVideo preload="auto" src="../../../../assets/about-company/about-kalpita/aboutUs.webm"
            class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
          </video>
        </div>
      </div>
    </div>
  </section>
</div>
<!-- Who We Are Section -->
<section class="solutions-section">
  <div class="container">
    <!-- Header -->
    <div class="section-header text-center mx-auto">
      <h2>Who We Are</h2>
    </div>

    <!-- ROW 1: TOP PART (Intro & Milestones) -->
    <!-- Added #topSection and [class.start-animation]="isTopVisible" -->
    <div class="row align-items-center mb-5" #topSection [class.start-animation]="isTopVisible">

      <!-- Left: Paragraph Text -->
      <div class="col-lg-5 mb-4 mb-lg-0">
        <p class="intro-text">
          Kalpita Technologies is a global software engineering and AI innovation company,
          where technology transforms possibilities into tangible outcomes. Founded with a
          mission to combine smart engineering with empathy, we help organizations
          reshape industries through purposeful innovation, trusted partnerships, and
          intelligent digital transformation.
        </p>
      </div>

      <!-- Right: Milestones -->
      <div class="col-lg-7">
        <div class="milestones-grid">
          <div class="milestone-card" *ngFor="let item of milestones">
            <div class="icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z" />
              </svg>
            </div>
            <div class="card-content">
              <h3 class="m-number">{{ item.number }}</h3>
              <p class="m-label">{{ item.label }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ROW 2: BOTTOM PART (Purpose & Values) -->
    <!-- Added #bottomSection and [class.start-animation]="isBottomVisible" -->
    <div class="row mt-5" #bottomSection [class.start-animation]="isBottomVisible">

      <!-- Left: Purpose & Mission -->
      <div class="col-lg-6 mb-4 mb-lg-0">
        <div class="solutions-content left-content pe-lg-4">
          <div class="mb-5 purpose-block"> <!-- Added class purpose-block for styling -->
            <h3>Our Purpose</h3>
            <p> To empower progress through purposeful technology, creating solutions that enhance human experience,
              foster
              meaningful impact, and drive sustainable digital transformation.</p>
          </div>

          <div class="mission-block"> <!-- Added class mission-block for styling -->
            <h3>Our Mission</h3>
            <p>
              To deliver reliable, human-centered, and scalable AI-powered software solutions that help businesses grow
              faster, serve customers better, and operate smarter.
              At Kalpita, we blend deep engineering expertise with empathy-driven design, enabling AI integration that
              transforms complexity into clarity and action.
            </p>
          </div>
        </div>
      </div>

      <!-- Right: Core Values -->
      <div class="col-lg-6">
        <div class="solutions-content right-content ps-lg-4">
          <h3>Our Core Values:</h3>
          <div class="core-values-list">
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Purposeful Innovation:</strong> We challenge limits to create technology that serves a greater
                good.
              </span>
            </div>
            <!-- ... Keep all other value items ... -->
            <!-- Add the rest of the value items here as per your original file -->
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Empathy-Driven Engineering:</strong> We build with heart, designing for people first.
              </span>
            </div>
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Excellence in Execution:</strong> Quality, reliability, and discipline define every project we
                deliver.
              </span>
            </div>
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Integrity & Trust:</strong> We operate with transparency, accountability, and commitment.
              </span>
            </div>
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Collaborative Spirit:</strong> We work as true partners - globally connected, locally committed.
              </span>
            </div>
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Continuous Learning:</strong> Growth and curiosity drive our evolution.
              </span>
            </div>
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Agility with Discipline:</strong> Nimble in action, consistent in quality.
              </span>
            </div>
            <div class="value-item">
              <img src="../../../assets/home/arrow-indicator.svg" class="arrow-icon" alt=">">
              <span>
                <strong>Transformation Focus:</strong> Technology that inspires positive change.
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ============== What We DO Section ================ -->
<section class="dev-process-section">
  <div class="container">
    <!-- Section Header -->
    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-9">
        <h2 class="section-heading-process">What We Do</h2>
        <p class="section-subheading-process mt-3">Kalpita Technologies transforms ideas into intelligent, scalable
          solutions that create measurable business impact. Through a unique blend of AI expertise, domain mastery, and
          human connection, we deliver software solutions that not only performs but also elevates. </p>
      </div>
    </div>

    <!-- Process Cards Container -->
    <div class="process-cards-container">
      <div class="process-card" *ngFor="let step of developmentProcess; let i = index"
        [ngClass]="{ 'card-blue': i % 2 === 0, 'card-white': i % 2 !== 0 }">

        <div class="process-icon-wrapper">
          <img [src]="step.icon" [alt]="step.title" class="process-icon">
        </div>

        <h3 class="process-title">{{ step.title }}</h3>
        <p class="process-description">{{ step.description }}</p>
      </div>
    </div>
  </div>
</section>
<!-- ============== Why We're Different Section ================ -->
<section class="pillars-section">
  <div class="container">
    <!-- Section Header -->
    <div class="section-header text-center mx-auto">
      <h2>Why Businesses Trust Kalpita</h2>
    </div>
    <!-- START: New Certifications Marquee Section -->
    <div class="partners-clients-card mb-5">
      <div class="scrolling-clients-wrapper">
        <div class="marquee">
          <div class="marquee-track">
            <!-- 
               We repeat the list 3 times to ensure seamless infinite scrolling.
               Please update the 'src' attributes to match the exact filenames in your assets folder.
            -->
            <ng-container *ngFor="let i of [1,2,3]">

              <!-- 1. SOC 2 -->
              <img src="../../../../assets/about-company/about-kalpita/Soc2.png" alt="SOC 2 Certified">

              <!-- 2. ISO -->
              <img src="../../../../assets/about-company/about-kalpita/ISO.png" alt="ISO Certified">

              <!-- 3. Google Reviews -->
              <img src="../../../../assets/about-company/about-kalpita/google.png" alt="Google">

              <!-- 4. Tech Partner (Purple Cube) -->
              <img src="../../../../assets/about-company/about-kalpita/Ambition-box.png" alt="Ambitin-box">

              <!-- 5. Glassdoor -->
              <img src="../../../../assets/about-company/about-kalpita/glassdoor.png" alt="Glassdoor">

              <!-- 6. Great Place To Work -->
              <img src="../../../../assets/about-company/about-kalpita/GPTW.png" alt="Great Place to Work">

              <!-- 7. Clutch -->
              <img src="../../../../assets/about-company/about-kalpita/Clutch.png" alt="Clutch">

              <!-- 8. GoodFirms -->
              <img src="../../../../assets/about-company/about-kalpita/Goodfirm.png" alt="GoodFirms">

            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="slide-content-wrapper" [attr.data-active-index]="activePillarSlide">
      <div class="row align-items-center">
        <!-- Left Column: Text Content -->
        <div class="col-lg-5">
          <div class="slide-text-content">
            <h3>{{ pillarSlides[activePillarSlide].title }}</h3>
            <p>{{ pillarSlides[activePillarSlide].description }}</p>
          </div>
        </div>

        <!-- Right Column: Frosted Glass Panel -->
        <div class="col-lg-7">
          <div class="pillar-image-panel">
            <div class="accent-shape-1"></div>
            <div class="accent-shape-2"></div>
            <div class="icon-grid-container single-image-mode">
              <div class="single-image-wrapper">
                <img [src]="pillarSlides[activePillarSlide].image" [alt]="pillarSlides[activePillarSlide].title"
                  class="pillar-main-image">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Carousel Dots -->
    <div class="pagination-indicators">
      <button *ngFor="let slide of pillarSlides; let i = index" class="dot" [class.active]="i === activePillarSlide"
        (click)="goToPillarSlide(i)"></button>
    </div>
  </div>
</section>
<!-- Meet Our Visionaries Section -->
<section class="visionaries-section">
  <div class="container-fluid"> <!-- Changed to fluid for flow effect -->

    <!-- Header -->
    <div class="section-header text-center mx-auto mb-5">
      <h2>Meet Our Leadership Team</h2>
      <p class="section-subtitle">Driving innovation and excellence across every department.</p>
    </div>

    <!-- Category Filter Pills (Like Screenshot 3) -->
    <div class="category-filter-container text-center mb-5">
      <div class="filter-pills-wrapper">
        <button *ngFor="let cat of visionaryCategories" class="filter-pill" [class.active]="selectedCategory === cat"
          (click)="filterVisionaries(cat)">
          {{ cat }}
        </button>
      </div>
    </div>

    <!-- Visionary Cards Slider -->
    <div class="visionary-slider-viewport">
      <!-- 
        The track contains two sets of the data to allow for seamless infinite scrolling 
        animation via CSS. 
      -->
      <div class="visionary-track"
        [ngClass]="{'animate-flow':  filteredVisionaries.length > 4}">

        <!-- SET 1 -->
        <div class="visionary-card-wrapper" *ngFor="let visionary of filteredVisionaries">
          <div class="visionary-card">
            <div class="card-image-box">
              <img [src]="visionary.image || 'assets/placeholder-user.jpg'" [alt]="visionary.name">
              <!-- The Wave Shape SVG Overlay -->
              <div class="wave-overlay">
                <svg viewBox="0 0 500 150" preserveAspectRatio="none">
                  <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                    style="stroke: none; fill: #ffffff;">
                  </path>
                </svg>
              </div>
            </div>
            <div class="card-content">
              <h4 class="v-name">{{ visionary.name }}</h4>
              <p class="v-role">{{ visionary.role }}</p>
            </div>
          </div>
        </div>

        <!-- SET 2 (Duplicate for Seamless Loop) - Only render if we have enough items to scroll -->
        <ng-container *ngIf=" filteredVisionaries.length > 4">
          <div class="visionary-card-wrapper" *ngFor="let visionary of filteredVisionaries">
            <div class="visionary-card">
              <div class="card-image-box">
                <img [src]="visionary.image || 'assets/placeholder-user.jpg'" [alt]="visionary.name">
                <div class="wave-overlay">
                  <svg viewBox="0 0 500 150" preserveAspectRatio="none">
                    <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                      style="stroke: none; fill: #ffffff;">
                    </path>
                  </svg>
                </div>
              </div>
              <div class="card-content">
                <h4 class="v-name">{{ visionary.name }}</h4>
                <p class="v-role">{{ visionary.role }}</p>
              </div>
            </div>
          </div>
        </ng-container>

      </div>
    </div>

  </div>
</section>
<!-- The Kalpita Journey -->
<section class="success-stories-section py-5">
  <div class="container">
    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-8">
        <h2 class="section-heading">The Kalpita Journey: 2018–Present</h2>
      </div>
    </div>
  </div>
  <div class="timeline-container">
    <div class="timeline-wrapper">
      <div class="content-layout">
        <!-- Cards Stack -->
        <div class="cards-stack">
          <div *ngFor="let item of visibleCards" class="card-wrapper" [class.card-top]="item.position === 'top'"
            [class.card-center]="item.position === 'center'" [class.card-bottom]="item.position === 'bottom'"
            (click)="selectCard(item.position)">

            <div class="card">
              <div class="card-image">
                <img [src]="item.card.image" [alt]="item.card.title">
                <div class="card-overlay"></div>
              </div>

              <div class="card-badge" *ngIf="item.position === 'center'">
                <span class="year-badge">{{ item.card.year }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-content">
          <ng-container *ngIf="cards.length > 0">
            <h2 class="content-year">{{ cards[selectedIndex].title }}</h2>
            <p class="content-description">{{ cards[selectedIndex].description }}</p>
          </ng-container>
        </div>

        <div class="carousel-dots-vertical" *ngIf="showCarouselDots">
          <button *ngFor="let card of cards; let i = index" class="dot" [class.active]="i === selectedIndex"
            (click)="goToCard(i)" [attr.aria-label]="'Go to ' + card.year">
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Our Culture & Values Snapshot Section -->
<section class="culture-snapshot-section" #cultureSection [class.start-animation]="isCultureVisible">
  <div class="container-fluid">

    <!-- Section Header -->
    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-8">
        <h2 class="section-heading">Our Culture & Values Snapshot</h2>
      </div>
    </div>

    <!-- Gallery Carousel -->
    <div class="gallery-carousel-wrapper" (mouseenter)="onGalleryMouseEnter()" (mouseleave)="onGalleryMouseLeave()">

      <!-- Only show if we have a full set of 4 images for the layout -->
      <div class="culture-gallery" *ngIf="currentGallerySlide.length >= 4">

        <!-- Left Large Image (Index 0) -->
        <div class="gallery-item item-left">
          <div class="image-wrapper">
            <img [src]="currentGallerySlide[0].image" alt="Culture snapshot">
          </div>
        </div>

        <!-- Middle Stacked/Overlapping Images (Index 1 & 2) -->
        <div class="gallery-item item-middle-container">
          <!-- Bottom/Back Image -->
          <div class="middle-card middle-large">
            <img [src]="currentGallerySlide[1].image" alt="Culture snapshot">
          </div>
          <!-- Top/Front Image -->
          <div class="middle-card middle-small">
            <img [src]="currentGallerySlide[2].image" alt="Culture snapshot">
          </div>
        </div>

        <!-- Right Large Image (Index 3) -->
        <div class="gallery-item item-right">
          <div class="image-wrapper">
            <img [src]="currentGallerySlide[3].image" alt="Culture snapshot">
          </div>
        </div>

      </div>
    </div>

    <!-- Visual Pagination Indicators -->
    <div class="visual-pagination" *ngIf="gallerySlides.length > 1">
      <span class="dot" *ngFor="let slide of gallerySlides; let i = index" [class.active]="i === activeGallerySlide"
        (click)="goToGallerySlide(i)">
      </span>
    </div>
  </div>
</section>
<!-- Local Presence & Global Collaboration Model Section -->
<section class="global-presence-section">
  <div class="container">
    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-10">
        <h2 class="section-heading">Local Presence & Global Collaboration Model</h2>
        <p class="section-intro">
          Kalpita Technologies has a strong local presence in <strong>Bangalore</strong> and the <strong>United
            States</strong> and is <strong>expanding</strong> into
          <strong>Tier 2 cities across India,</strong> supported by a strategically connected global footprint in the
          <strong>US</strong> and <strong>Latin America.</strong>
          Our People-First Nearshore Advantage ensures seamless, cost-effective collaboration, aligning teams across
          India, the US, and the UK. This model enables us to deliver innovative IT solutions, AI-powered projects, and
          digital transformation services to clients worldwide while fostering regional talent and driving industry
          growth.
        </p>
      </div>
    </div>

    <!-- REPLACED CONTENT: Single Map Image -->
    <div class="row justify-content-center">
      <div class="col-lg-10 text-center">
        <div class="map-container">
          <!-- Update the src below to your actual map image path -->
          <img src="../../../../assets/about-company/about-kalpita/localpresenceandglobal.png"
            alt="Kalpita Global Presence Map" class="img-fluid global-map-image">
        </div>
      </div>
    </div>

  </div>
</section>
<!-- FAQ -->
<app-faq [faqList]="aboutKalpitaFaqs"></app-faq>
<!-- Partner with purpose -->
<section class="partner-section" #partnerSection [class.start-animation]="isPartnerVisible">
  <div class="container">
    <div class="row justify-content-center text-center mb-5">
      <div class="col-lg-10">
        <h2 class="section-heading">Partner with Purpose</h2>
      </div>
    </div>

    <div class="row align-items-center">
      <!-- Left Column: Image -->
      <div class="col-lg-6">
        <!-- ADDED: #tiltCard reference for 3D effect -->
        <div class="vr-image-card" #tiltCard>
          <img src="../../../../assets/about-company/about-kalpita/Partner-with-Purpose.png"
            alt="Man wearing VR headset with digital overlay" class="img-fluid">
        </div>
      </div>
      <!-- Right Column: CTA Content -->
      <div class="col-lg-6">
        <div class="cta-content">
          <p class="cta-text">
            Let’s create intelligent solutions together that accelerate your business and empower transformation.
          </p>
          <button class="btn btn-contact-us" (click)="exploreOurSolutions()">Let’s Innovate Together</button>
        </div>
      </div>
    </div>
  </div>
</section>